import React, { useState, useEffect, useRef } from 'react'
import * as api from '../services/api.js'
import { todayShort } from '../utils/dates.js'

export default function Modal({ isOpen, onClose }) {
  const [input, setInput] = useState('')
  const [things, setThings] = useState([])
  const inputRef = useRef(null)

  useEffect(() => { api.getGoodThings().then(d => setThings(d || [])) }, [])

  // Focus input when modal opens
  useEffect(() => {
    if (isOpen) setTimeout(() => inputRef.current?.focus(), 100)
  }, [isOpen])

  // Close on Escape key
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  function save() {
    const text = input.trim()
    if (!text) return
    const entry = { date: todayShort(), text }
    setThings(prev => [entry, ...prev].slice(0, 50))
    api.saveGoodThing(entry)
    setInput('')
  }

  function onKeyDown(e) {
    if (e.key === 'Enter') save()
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay open" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className="modal-box">
        <h3>Something good</h3>
        <p>A tiny moment, a small win, anything at all.</p>
        <input
          ref={inputRef}
          className="modal-input"
          type="text"
          placeholder="Write it here..."
          maxLength={200}
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={onKeyDown}
        />
        <div className="modal-actions">
          <button className="modal-cancel" onClick={onClose}>Cancel</button>
          <button className="modal-save" onClick={save}>Save it</button>
        </div>
        <div className="good-things-list">
          {things.slice(0, 8).map((t, i) => (
            <div key={i} className="good-thing-item">
              <span className="good-thing-date">{t.date}</span>
              <span>{t.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
